import { createEntityAdapter } from '@ngrx/entity';
import { EmailMessage } from '../models/email-message.model';

export const emailMessageEntityAdapter = createEntityAdapter<EmailMessage>({
  selectId: emailMessage => emailMessage.id,
  sortComparer: sortByTimeAsc
});

function sortByTimeAsc(a: EmailMessage, b: EmailMessage): number {
  return a.time.localeCompare(b.time) ?? 0;
}
